import { createApi } from '@reduxjs/toolkit/query/react';

// Utils
import { HttpMethod, createBaseQuery } from '../base';

// Types
import PortfolioHolding from '@/types/portfolio-holding';

type StartJobResponse = {
  jobId: string;
};

export enum JobStatus {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type AIStatementReaderPortfolioJobSummary = {
  partialPortfolioExtraction: boolean; // if we detect X number of portfolios but can only extract data for Y
  partialInstrumentMatch: boolean; // if we could not match all holdings to instruments in at least 1 portfolio
  detectedPortfolios: number;
  extractedPortfolios: number;
};

export type JobStatusAndResults = {
  status: JobStatus;
  data: {
    summary: AIStatementReaderPortfolioJobSummary;
    portfolios: Array<{
      holdings: PortfolioHolding[];
      name?: Record<string, string>;
      size?: number;
    }>;
  } | null;
};

export const aiStatementReaderApi = createApi({
  reducerPath: 'aiStatementReaderApi',
  baseQuery: createBaseQuery(),
  endpoints: builder => ({
    /**
     * Start an async job to process an uploaded statement file
     */
    startJob: builder.mutation<StartJobResponse, FormData>({
      query: formData => ({
        url: 'jobs/read-statement/',
        method: HttpMethod.POST,
        body: formData,
      }),
    }),

    /**
     * Poll for job status and results
     * Returns status while processing, includes portfolios array when finished
     */
    getJob: builder.query<JobStatusAndResults, string>({
      query: jobId => `jobs/read-statement/${jobId}/`,
      // Automatically polls every 1 second when this query is active
      // Polling will stop when component unmounts or skip: true is set
    }),
  }),
});

export const { useStartJobMutation, useGetJobQuery } = aiStatementReaderApi;

export default aiStatementReaderApi;
